export default __webpack_public_path__ + "static/media/ICIntegration.57515162.svg";